import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Contemporary_Period_-_Globalization.png';

function HistoryPageGlobalizationGo() {
  return (
    <QuizPage
      title="History: Globalization"
      subTopic="Globalization"
      backgroundImage={historyImage}
      returnPath="/History-Globalization"
    />
  );
}

export default HistoryPageGlobalizationGo;
